import { collection, doc, getDoc, getDocs, limit, orderBy, query, runTransaction, serverTimestamp, startAfter } from "firebase/firestore";
import { auth, db } from "../firebase";
import { DOCUMENT_IDS, contentSignature, prepareContent } from "../content/cabinetSchema";
export { watchAdminAccess as watchCabinetAccess } from "./adminAccessService";
export async function loadCabinetContent() {
  const snapshots = await Promise.all(DOCUMENT_IDS.map(id => getDoc(doc(db, "siteContent", id))));
  return Object.fromEntries(snapshots.map((s, i) => [DOCUMENT_IDS[i], s.exists() ? s.data() : null]));
}
export async function saveCabinetContent(changes, baseline, reason = "edit") {
  const user = auth.currentUser;
  if (!user) throw new Error("Увійдіть як адміністратор.");
  const ids = Object.keys(changes);
  if (!ids.length || ids.some(id => !DOCUMENT_IDS.includes(id))) throw new Error("Невідомий розділ контенту.");
  const prepared = Object.fromEntries(ids.map(id => [id, prepareContent(id, changes[id])]));
  const refs = ids.map(id => doc(db, "siteContent", id));
  const auditRefs = ids.map(id => doc(collection(db, "cabinetContentHistory", id, "versions")));
  await runTransaction(db, async transaction => {
    // All reads precede writes. Compare the original snapshot, including legacy documents without revisions.
    const snapshots = await Promise.all(refs.map(ref => transaction.get(ref)));
    snapshots.forEach((snapshot, index) => {
      const id = ids[index];
      const before = snapshot.exists() ? snapshot.data() : null;
      if (contentSignature(before) !== contentSignature(baseline[id])) {
        throw Object.assign(new Error("Контент уже змінено іншим адміністратором. Оновіть дані перед збереженням."), {
          code: "content-conflict",
          documentId: id
        });
      }
    });
    snapshots.forEach((snapshot, index) => {
      const id = ids[index];
      const before = snapshot.exists() ? snapshot.data() : null;
      const after = {
        ...prepared[id],
        _meta: {
          revision: (before?._meta?.revision || 0) + 1,
          updatedAt: serverTimestamp(),
          updatedBy: user.uid,
          historyId: auditRefs[index].id
        }
      };
      transaction.set(refs[index], after);
      transaction.set(auditRefs[index], {
        documentId: id,
        before,
        after,
        action: reason,
        actorUid: user.uid,
        createdAt: serverTimestamp(),
        revision: after._meta.revision
      });
    });
  });
}
export async function getCabinetHistory(id, cursor) {
  if (!DOCUMENT_IDS.includes(id)) throw new Error("Невідомий розділ.");
  const constraints = [orderBy("createdAt", "desc"), limit(10)];
  if (cursor) constraints.push(startAfter(cursor));
  const snapshot = await getDocs(query(collection(db, "cabinetContentHistory", id, "versions"), ...constraints));
  return {
    items: snapshot.docs.map(s => ({
      id: s.id,
      ...s.data()
    })),
    cursor: snapshot.docs.at(-1),
    hasMore: snapshot.size === 10
  };
}
